import useSWR from 'swr';
import { API_HOST } from '../helpers/constants';
import { fetcher } from '../utils';

export function useBlogPost(id) {
  const url = `${API_HOST}/blog-posts/${id}`;

  const { data: responseData, error, isLoading, mutate } = useSWR(id ? url : null, fetcher);

  const revalidate = () => mutate(url);

  return {
    blogPost: responseData,
    isLoading,
    isError: error,
    revalidate
  };
}
